<template>
  <div class="vb-detail-view">
    <b-container>
      <trigger-booking-engine :is_open="be_open" @toggle="be_open = $event" />
      <booking-engine :is_open="be_open" @search="handle_search()" />

      <section v-if="searching || loading" class="section section--loader">
        <loader size="large" :show_timing_slot="true" />
      </section>

      <section v-else-if="detail_error" class="section">
        <b-alert show variant="danger">
          Si è verificato un errore durante il caricamento dei dettagli. Torna
          alla ricerca e riprova.
        </b-alert>
        <div class="d-flex justify-content-center mt-3">
          <router-link :to="{ name: 'results' }">
            <vb-button
              :vb_options="{ text: 'Torna ai risultati', variant: 'info' }"
            />
          </router-link>
        </div>
      </section>

      <section v-else class="section">
        <div v-if="last_search !== current_search">
          <b-alert show variant="warning">
            Attenzione, hai cambiato i criteri di ricerca ma non hai aggiornato
            i risultati. Clicca su Cerca.
          </b-alert>
          <br /><br />
        </div>

        <detail-only-stay
          v-if="is_only_stay_package"
          :hotel_data="hotel_data"
        />

        <detail-flight-and-stay
          v-else
          :product_detail="product_detail"
          :statics_detail="statics_detail"
          :supplement="supplement"
          :product_brand="product_brand"
        />
      </section>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import { deep_clone } from '@utilities/commons';
  import { alpitour_service_handler } from '@alpitour/services/common';
  import { endpoints_keys } from '@alpitour/resources';
  import { process_response as process_flight_and_stay } from '@alpitour/utilities/detail-flight-and-stay';
  import {
    alpitour_rybbit_event,
    slim_detail_params,
  } from '@alpitour/utilities/rybbit';
  import DetailFlightAndStay from '@alpitour/components/views/content-blocks/detail-flight-and-stay.vue';
  import DetailOnlyStay from '@alpitour/components/views/content-blocks/detail-only-stay.vue';
  import TriggerBookingEngine from '@components/atoms/trigger-booking-engine.vue';

  export default {
    name: 'detail-view',

    components: {
      'detail-flight-and-stay': DetailFlightAndStay,
      'detail-only-stay': DetailOnlyStay,
      'trigger-booking-engine': TriggerBookingEngine,
    },

    data() {
      return {
        be_open: false,
        loading: true,
        occupancy: deep_clone(this.$store.state.occupancy),
        flex_dates: this.$store.state.liveat.flex_dates,
        pid: this.$store.state.liveat.pid,
        detail_error: false,
        departure_date: this.$store.state.liveat.departure_date,
        departure_airports: this.$store.state.liveat.departure_airports,
        product_detail: [],
        statics_detail: {},
        supplement: [],
        product_brand: '',
        hotel_data: {},
      };
    },

    computed: {
      // global state keys
      ...mapState(['searching']),
      // module state keys
      ...mapState('liveat', ['last_search', 'current_search']),
      ...mapGetters('liveat', ['is_only_stay_package']),
    },

    mounted() {
      alpitour_rybbit_event('detail:page:view');
      const detail_params = this.$store.state.liveat.detail_params || {};

      if (!this._validate_detail_params(detail_params)) return;

      if (this.is_only_stay_package) {
        alpitour_service_handler(
          endpoints_keys.details, 
          detail_params,
          {
            track: {
              name: 'detail', 
              phase: 'load'
            },
          }
        ).then(
          (success) => {
            this.log('[detail.vue] - only_stay success');
            this.hotel_data = success.data;
            this.loading = false;
          }
        );
      } else {
        alpitour_service_handler(
          endpoints_keys.price, 
          detail_params,
          {
            track: {
              name: 'detail', 
              phase: 'load'
            },
          }
        ).then(
          (success) => {
            this.log('[detail.vue] - flight_and_stay success');
            const result = process_flight_and_stay(success, {
              departure_airports: this.departure_airports,
              departure_date: this.departure_date,
            });
            this.product_detail = result.product_detail;
            this.supplement = result.supplement;
            this.statics_detail = result.statics_detail;
            this.product_brand = this.$store.state.liveat.pid.split('-')[1];
            this.loading = false;
          }
        );
      }
    },

    methods: {
      // Valida i parametri in base al flusso attivo:
      // only-stay richiede ext_id, flight-and-stay richiede pid e non deve avere solution_id
      _validate_detail_params(detail_params) {
        const { ext_id, solution_id, pid } = detail_params;
        const is_invalid = this.is_only_stay_package
          ? !ext_id
          : !pid || solution_id;

        if (is_invalid) {
          alpitour_rybbit_event(
            'package:type:missmatch',
            slim_detail_params(detail_params, this.is_only_stay_package)
          );
          window.eventBus.$emit('got_modal_notification', {
            msg: 'Qualcosa è andato storto, prova una nuova ricerca!',
            routerPush: 'homepage',
          });
          return false;
        }
        return true;
      },
      handle_search() {
        this.be_open = false;
        this.$router.push({ name: 'results' });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
